import React from "react";
import Home from "./Components/Home";
import Splahs from "./Components/Splash/Splahs";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";

const App = () => {
  return (
    <div>
        <BrowserRouter>
        <Routes>

          <Route path="/balady/:id" element={<Splahs />} />
          <Route path="/HealthIssue/PrintedLicenses/:id" element={<Splahs />} />

          <Route path="/" element={<Home />} /> {/* Added the Home route */}
          


        </Routes>
        </BrowserRouter>
    </div>
  );
};

export default App;
